import { AbstractControl, ValidatorFn } from '@angular/forms';

export class CustomValidators {
  public static namePattern = '^(\\s*[A-Za-z0-9]+\\s*)+$';
  public static notEmojisPattern =
    /^[^\u{1F300}-\u{1F64F}\u{1F680}-\u{1F6FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{1F900}-\u{1F9FF}\u{1F1E0}-\u{1F1FF}]*$/u;
  public static noDotPattern = '^[^.]*$';
  public static titlePattern = '^(\\s*[A-Za-z0-9.,&\\-\\/]+\\s*)+$';
  public static mailPattern = '^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[a-z]{2,4}$';
  public static urlPattern =
    '^(((http|https|ftp)(:\\/\\/)){1}((www).)?)[-a-zA-Z0-9:%._+~#=]{1,256}\\.?[a-zA-Z0-9()]{1,6}\\b([-a-zA-Z0-9():%_+.~#?&//=]*)$';
  public static simpleUrlPattern =
    '^(www\\.)[-a-zA-Z0-9:%._+~#=]{1,256}\\.[a-zA-Z0-9()]{1,6}\\b([-a-zA-Z0-9():%_+.~#?&//=]*)$';

  public static notFilledWithWhitespace(control: AbstractControl): null | Record<string, boolean> {
    return (control.value || '').trim().length === 0 ? { whitespace: true } : null;
  }

  public static stringNotEqualTo(stringVal: string): ValidatorFn {
    return (control: AbstractControl): Record<string, boolean> | null => {
      return control.value === stringVal ? { stringNotEqualTo: true } : null;
    };
  }

  public static maxByteLength(maxLength: number) {
    return (control: AbstractControl): Record<string, boolean> | null => {
      const encoder = new TextEncoder();
      const isValid = encoder.encode(control.value).length >= maxLength;
      return isValid ? { maxByteLength: true } : null;
    };
  }

  public static blacklist(list: string[]) {
    const listCase = list.map((item) => item?.toLowerCase());
    return (control: AbstractControl): Record<string, boolean> | null => {
      const contains = listCase.includes(control.value?.toLowerCase());
      return contains ? { blacklist: true } : null;
    };
  }

  public static isValidUrl() {
    return (control: AbstractControl): Record<string, boolean> | null => {
      try {
        new URL(control.value);
        return null;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
      } catch (_) {
        return { isValidUrl: true };
      }
    };
  }
}
